<template>
    <div class="location-block wow fadeInRight" tabindex="0">
        <h4 class="ttl">
            <span>Location</span>
            <a href="javascript:void(0)" @click="showDirection">Get Direction</a>
        </h4>
        <div class="firm-wrap">
            <!-- <div class="company-logo">
                <img src="img/logo1.jpg" alt="company logo">
            </div> -->
            <p class="company-name ml-0">{{ inner_member.company }}</p>
        </div>
        <div class="contacr-wrap">
            <dl class="contacts">
                <dt><i class="fas fa-map-marker-alt map-marker"></i></dt>
                <dd v-html="inner_member.address"></dd>
            </dl>
            <dl class="contacts">
                <dt><i class="fas fa-phone"></i></dt>
                <dd>
                    {{ inner_member.cellphone ? inner_member.cellphone : 'N/A' }}
                </dd>
            </dl>
            <dl class="contacts">
                <dt><i class="fas fa-globe"></i></dt>
                <dd>
                    <a
                        target="_blank"
                        rel="noopener noreferrer"
                        v-if="inner_member.website"
                        :href="getWebSite"
                    >
                        {{ getWebSite }}
                    </a>
                    <a v-else>N/A</a>
                </dd>
            </dl>
        </div>
        <div class="map" id="map">
            <MembersItemMap
                ref="membersItemMap"
                :input_center="inner_center"
                :input_member="inner_member"
            >
            </MembersItemMap>
        </div>
    </div>
</template>

<script>
    import MembersItemMap from "./MembersItemMap";

    export default {
        name: "MembersItemLocation",
        components: {
            MembersItemMap
        },
        props: {
            inner_center: {
                type: Object,
                required: true,
                default: function () {
                    return {
                        lat : 41.850033,
                        lng : -98.6500523
                    }
                },
            },
            inner_member: {
                type: Object,
                required: true
            }
        },
        computed: {
            getWebSite() {
                const websiteLink = this.inner_member.website;

                return (!websiteLink.startsWith("http://") && !websiteLink.startsWith("https://")) ?
                    "https://" + websiteLink :
                    websiteLink;
            }
        },
        methods: {
            showDirection() {
                if (this.$refs.membersItemMap.user.error) {
                    this.$swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: this.$refs.membersItemMap.user.error
                    });
                } else {
                    this.setDirection();
                }
            },
            setDirection() {
                const directionsService = new google.maps.DirectionsService();
                const directionsDisplay = new google.maps.DirectionsRenderer();
                const memberMap = this.$refs.membersItemMap;

                directionsDisplay.setMap(memberMap.$refs.googleMap.$mapObject);

                const request = {
                    origin: memberMap.user.formatted_address,
                    destination: memberMap.marker.formatted_address,
                    travelMode: 'DRIVING'
                };

                directionsService.route(request, (response, status) => {
                    if (status === 'OK') {
                        directionsDisplay.setDirections(response);

                        this.centerMapByMarkers(memberMap.user, memberMap.marker);
                    } else {
                        this.$swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: `Directions request failed! ${status === 'ZERO_RESULTS' ? 'Unable to get route between those addresses' : ''}`
                        });
                    }
                })
            },
            centerMapByMarkers(origin, destination) {
                this.$refs.membersItemMap.$refs.googleMap.$mapPromise.then((map) => {
                    const bounds = new google.maps.LatLngBounds();
                    const markers = [
                        {
                            lat: origin.position.lat,
                            lng: origin.position.lng
                        },
                        {
                            lat: destination.currentPosition.lat,
                            lng: destination.currentPosition.lng
                        }
                    ]

                    for (let marker of markers) {
                        bounds.extend(marker)
                    }
                    map.fitBounds(bounds);
                });
            },
        }
    }
</script>
